import script from "./Comments.vue?vue&type=script&setup=true&lang=js"
export * from "./Comments.vue?vue&type=script&setup=true&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=ac52ffc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac52ffc8"]])

export default __exports__